import Vue from 'vue'

import Vuex from 'vuex'
import {vantLocales} from '@/i18n'

Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        //这里放全局参数
        userInfo: {},
        baseInfo: {},
        language: localStorage.getItem('lang') || process.env.VUE_APP_LANG // 项目初始化时，默认为浏览器的语言
    },
    mutations: {
        setUserInfoValue(state, Value) {
            state.userInfo = Value
        },
        setBaseInfoValue(state, Value) {
            state.baseInfo = Value
        },
        setLanguage: (state, language) => {
            state.language = language
            localStorage.setItem('lang', language)
            vantLocales(language)
        },
    },
    getters: {
        //get方法
        getUserInfo: state => state.userInfo,
        getBaseInfo: state => state.baseInfo,
        language: state => state.language,
    },
    actions: {
        //这个部分我暂时用不上
    },
    modules: {
        //这里是我自己理解的是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里
    }
})